import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Segment, Tab, Header, Loader } from 'semantic-ui-react' 
import {
    generateInvoice
} from '../../actions/productsActions.js';

class ViewInvoicePage extends Component {
    state = {
        invoiceId:null
    }

    componentDidMount() { 
        const { search } = this.props.location; 
        const parsedQueryString = search.split('?')
        let params = {}
        for (let i=1; i<parsedQueryString.length; i++){
            let splitQuery = parsedQueryString[i].split('=')
            params[splitQuery[0]] = splitQuery[1]
            if (splitQuery[0] == 'invoiceId'){
                this.setState({invoiceId:splitQuery[1]})
            }
        }  
        this.props.generateInvoice(params.uuid,params.userUUID) 
    }
    render() { 
        if (this.props.products.loading) {
            return <Loader active />
        }
        return(
            <div>
                <Header as='h4' attached='top' block>
                                Tax Invoice ID : {this.state.invoiceId}
                </Header>
                <Segment attached>
                {this.props.products && this.props.products.invoice &&  
                    <iframe 
                    src={`data:application/pdf;base64,${this.props.products.invoice}`} 
                    height="850" 
                    width="100%" 
                    frameBorder="0"> 
                    </iframe>
                } 
                </Segment>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        // user: state.user.user,
        products: state.products,
    }
}

export default connect(mapStateToProps, {generateInvoice
})(ViewInvoicePage);